import { css } from '@emotion/core';
import { media, tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var newItem = _ref2 => {
  var alignment = _ref2.alignment,
    _ref2$desktop = _ref2.desktop,
    desktop = _ref2$desktop === void 0 ? false : _ref2$desktop;
  return /*#__PURE__*/css("position:relative;top:-6px;margin-left:8px;padding:1px 8px;", applyFont(typography.miniBold), ";background-color:", colors.success.subdued.default, ";color:", colors.neutral.heavy.default, ";border-radius:5px;", alignment === 'right' && /*#__PURE__*/css("position:absolute;right:", desktop ? 32 : 40, "px;top:2px;"));
};
export var list = /*#__PURE__*/css("margin-left:0.1em;", applyFont(typography.body));
var _ref = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var item = _ref3 => {
  var alignment = _ref3.alignment;
  return /*#__PURE__*/css("display:table;margin-bottom:15px;position:relative;", media('>=desktop'), "{margin-bottom:10px;}", alignment === 'right' && _ref);
};